/**
* @name: xm-file-drag
* @author: weiyong
* @date: 2023-06-08 14:10
* @description：xm-file-drag
* @update: 2023-06-08 14:10
* @remark: HHHH
*/
<template>
  <div class="xm-file-input-div" :id="dragViewId">
    <a-upload-dragger
      :headers="headers"
      :accept="acceptString"
      :data="dataUpload"
      :before-upload="beforeUpload"
      name="file"
      v-if="!disabled"
      :disabled="disabled"
      :multiple="multiple"
      :action="uploadAction"
      @change="handleChange"
      @remove="removeFile"
      :showUploadList="false"
      :openFileDialogOnClick="true"
    >
      <!--      附件上传说明信息-->
      <xm-file-upload-infos :ctlProps="ctlProps" :filetype="filetype" :showFileTypes="showFileTypes"/>
    </a-upload-dragger>
    
    <!-- 上传进度条 -->
    <div v-if="uploadingFiles && uploadingFiles.length > 0" class="upload-progress-wrapper">
      <div v-for="uploadFile in uploadingFiles" :key="uploadFile.uid" class="upload-progress-item">
        <div class="progress-info">
          <span class="progress-filename">
            <loading-outlined v-if="uploadFile.percent < 100" />
            <check-circle-outlined v-else style="color: #52c41a;" />
            {{ uploadFile.name }}
          </span>
          <span class="progress-percent">{{ uploadFile.percent }}%</span>
        </div>
        <a-progress 
          :percent="uploadFile.percent" 
          :show-info="false"
          :status="uploadFile.percent === 100 ? 'success' : 'active'"
          :stroke-color="{
            '0%': '#108ee9',
            '100%': '#52c41a',
          }"
        />
      </div>
    </div>
    
    <template v-if="ctlProps.userFileTemp&&disabled">
      <!--      自定义附件预览列表-->
      <slot name="userTemp" :fileList="fileList" :fileCtls="fileCtls"></slot>
    </template>
    <template v-else>
      <template v-if="fileList.length===0 && (!uploadingFiles || uploadingFiles.length===0)">
        <div class="w100b flex-div" style="justify-content: center;color:#888;">暂无附件信息！</div>
      </template>
      <!--      附件预览设置-->
      <file-show-list :fileAclInfo="fileAclInfo"
                      :colsFile="ctlProps.colsFile"
                      v-if="fileAclInfo.preview||fileAclInfo.download"
                      :fileList="fileList"
                      @flushFileList="flushFileList"
                      :businessId="businessId"></file-show-list>
    </template>
    <!--    模版下载设置-->
    <xm-down-temp :downUrl="downUrl"
                  :tepFileName="tepFileName"
                  :tableCode="tableCode" :fileTempDownUrl="fileTempDownUrl" v-if="tempDownLink"/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xm-file-input",
});
</script>

<script lang="ts" setup>
import {UploadDragger as AUploadDragger, Progress as AProgress} from "ant-design-vue";
import {LoadingOutlined, CheckCircleOutlined} from "@ant-design/icons-vue";
import FileShowList from './coms/file-show-list.vue';
import XmFileUploadInfos from "@/components/fileCtl/component/xm-file-upload-infos.vue";
import XmDownTemp from "@/components/fileCtl/component/xm-down-temp.vue";
//附件操作列表
import {useComFileUpload} from "@/components/fileCtl/hooks/useComFileUpload";
import {ref, unref, onMounted, toRefs, computed} from "vue";
import {GoingNewUtils} from 'xmgoing-utils'

const fileCtls = ref({
  preview: true,
  download: true,
  delete: true,
})

interface propTypes {
  loadFileFlag:any;
  fileAclInfo: any,
  downUrl: string,
  tepFileName: string,
  selValue: boolean,
  fileTempDownUrl: string,
  showFileTypes: boolean,
  tempDownLink: boolean,
  previewFlag: boolean,
  label: string,
  listType: string,
  tableCode: string,
  businessId: string,
  filetype: string,
  accept: any,
  selImgFlag: boolean,
  preViewWidth: number,
  uploadAction: string,
  base64: boolean,
  fileId: string,
  isImgValue: string,
  executeFlag: boolean,
  value: string,
  ctlProps: any,
  selSystemImg: boolean,
  disabled: boolean,
  multiple: boolean,
}

const props = withDefaults(defineProps<propTypes>(), {
  fileAclInfo: {download: true, preview: true, delete: false, upload: true},
  showFileTypes: false,
  downUrl: '',
  loadFileFlag:'',
  fileTempDownUrl: '',
  isImgValue: '',
  selValue: false,
  previewFlag: true,
  businessId: '',
  filetype: '',
  multiple: true,
  tempDownLink: false,
  selSystemImg: true,
  preViewWidth: 100,
  fileId: '',
  value: '',
  tepFileName: '',
  tableCode: '',
  accept: [],
  disabled: false,
  ctlProps: '',
  base64: false,
  uploadAction: '',
  selImgFlag: false,
  executeFlag: true,
  listType: 'picture',
  label: '',
})
const {businessId, value, selValue,loadFileFlag} = toRefs(props);

// 将 accept 数组转换为字符串格式，供 Ant Design Vue Upload 组件使用
const acceptString = computed(() => {
  const acceptProp = unref(props).accept;
  if (Array.isArray(acceptProp) && acceptProp.length > 0) {
    // 将 MIME 类型数组转换为逗号分隔的字符串
    return acceptProp.join(',');
  }
  return undefined; // 如果没有限制，返回 undefined
});


const winWidth = ref(500);

const dragViewId = GoingNewUtils.getUUChar(20);

onMounted(() => {
  if (unref(value)) {
    fileList.value.push({
      fileName: unref(value)
    });
  }
  winWidth.value = (document.getElementById(dragViewId) as any)?.clientWidth;
  
  // 调试信息
  console.log('=== xm-file-input 组件初始化 ===');
  console.log('uploadAction:', unref(uploadAction));
  console.log('businessId:', unref(businessId));
  console.log('disabled:', unref(props).disabled);
  console.log('accept 原始值:', unref(props).accept);
  console.log('accept 类型:', typeof unref(props).accept);
  console.log('accept 是否为数组:', Array.isArray(unref(props).accept));
  console.log('acceptString 计算值:', acceptString.value);
  console.log('headers:', unref(headers));
  console.log('dataUpload:', unref(dataUpload));
  console.log('beforeUpload 函数:', beforeUpload);
  console.log('handleChange 函数:', handleChange);
  console.log('================================');
})


const emits = defineEmits([
  'clearFileList',
  'update:value', 'update:busId', 'beforeUpload',
  'change', 'done', 'error',
]);
const ctx = {emit: emits}

//附件操作
const {
  getFileList,
  clearFileList,
  removeFile,
  flushFileList,
  dataUpload,
  handleChange,
  beforeUpload,
  fileList,
  headers,
  uploadAction,
  uploadingFiles,  // 正在上传的文件列表（带进度）
} = useComFileUpload({
  loadFileFlag,
  selValue,
  userUploadAction: unref(props).uploadAction,
  props,
  ctx,
  businessId,
  fileId: props.fileId
}, null);

defineExpose({clearFileList, getFileList})
</script>

<style type="text/css" lang="less">
.xm-file-input {
  .ant-upload-drag-icon {
    padding: 0 12px;

    svg {
      font-size: 22px;
      color: var(--primary-color, #0a6eff);
    }
  }

}

.xm-file-input-div {
  .ant-upload.ant-upload-drag {
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    background: #fafafa;
    transition: border-color 0.3s;
    
    &:hover {
      border-color: var(--primary-color, #0a6eff);
    }
    
    .ant-upload {
      padding: 16px 0;
      min-height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .ant-upload-drag-container {
      width: 100%;
    }
  }
  
  // 拖拽时的高亮效果
  .ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled) {
    border-color: var(--primary-color, #0a6eff);
    background: #e6f7ff;
  }
  
  // 上传进度条样式
  .upload-progress-wrapper {
    margin-top: 16px;
    
    .upload-progress-item {
      margin-bottom: 12px;
      padding: 12px 16px;
      background: #f5f5f5;
      border-radius: 4px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .progress-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        
        .progress-filename {
          font-size: 14px;
          color: #333;
          font-weight: 500;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: flex;
          align-items: center;
          gap: 8px;
          
          .anticon {
            font-size: 16px;
          }
        }
        
        .progress-percent {
          font-size: 14px;
          color: #1890ff;
          font-weight: 600;
          margin-left: 12px;
          min-width: 45px;
          text-align: right;
        }
      }
    }
  }
}

.listForm {
  &.xmForm {
    .xm-file-list-wrap .xm-file-list-item {
      border: 0;
    }
  }
}
</style>
